<script setup lang="ts">
import type { UserMayHavePicture } from '@global-types/userMayHavePicture';
import { computed } from 'vue';
import MediaImage from '@components/MediaImage.vue';
import { type Color, getColorValue } from '@global-types/colors';

const props = withDefaults(defineProps<{
  user: UserMayHavePicture,
  size?: number,
}>(), {
  size: 24,
});

const initials = computed<string>(() => {
  const { firstname } = props.user;
  return firstname[0].toUpperCase();
  // @todo Standby for now, specs to come
  // const lastname = props.user.lastname;
  // return firstname[0].toUpperCase() + lastname[0].toUpperCase();
});

const colors: Color[] = [ 'green', 'blue', 'red', 'yellow', 'orange', 'black', 'purple' ];

const backgroundColor = computed<string>(() => {
  const letter = initials.value[0];
  if (!letter) {
    return 'black';
  }
  const normalized = letter.toUpperCase().charCodeAt(0);
  const index = normalized % colors.length;
  return getColorValue(colors[index]);
});
</script>

<template>
  <div class="user-picture">
    <div
      v-if="user.profile_picture"
      class="user-picture__image picture-image"
      :style="{ width: `${size}px`, height: `${size}px` }"
    >
      <MediaImage
        class="picture-image__media"
        :uuid="user.profile_picture.uuid"
        :alt="user.full_name"
        :ratio="[ 1, 1 ]"
        :width="size"
        :height="size"
        :crop="[ size, size ]"
        :draggable="false"
      />
    </div>
    <div
      v-else
      class="user-picture__initials"
      :style="{ width: `${size}px`, height: `${size}px`, backgroundColor }"
    >
      {{ initials }}
    </div>
  </div>
</template>
